﻿// home-made parsing of react-validation HOC form 

export default function getValues(form) {
    let rawValues = Object.keys(form.state.byName).reduce((values, name) => {

        if (form.state.byName[name].length > 1) {
            values[name] = form.state.byName[name].map(id => {
                let inputEl = document.getElementById(form.state.byId[id].id);

                if ('data-ignore-on-signup' in form.state.byId[id]) {
                    return null;
                }

                if ((inputEl.type == 'radio' || inputEl.type == 'checkbox') && !inputEl.checked) {
                    return null;
                }

                if (form.state.byId[id].value == 'true' || form.state.byId[id].value == 'false') {
                    return Boolean(form.state.byId[id].value);
                } else {
                    return form.state.byId[id].value;
                }

            });
        } else {
            if ('data-ignore-on-signup' in form.state.byId[form.state.byName[name][0]]) {
                return values;
            }

            let inputEl = document.getElementById(form.state.byId[form.state.byName[name][0]].id);
            if (inputEl && (inputEl.type == 'radio' || inputEl.type == 'checkbox')) {
                values[name] = inputEl.checked ? form.state.byId[form.state.byName[name][0]].value : false;
            } else {
                values[name] = form.state.byId[form.state.byName[name][0]].value;
            }

            if (values[name] == 'true' || values[name] == 'false') {
                values[name] = Boolean(values[name]);
            }
        }

        return values;
    }, {});

    let values = null;
    // check for multiple input name duplicates scenario => arrays of name-indexed values (i.e. groupName in HomeStep1Form)
    if (Array.isArray(rawValues.groupName)) {
        let filledIndex = rawValues.insuranceName.findIndex(v => v != null);
        values = Object.keys(rawValues).reduce((res, key) => {
            res[key] = rawValues[key][filledIndex];
            return res;
        }, {});

    } else { // normal scenario, remove null values and fix name "arrays" (name="blah[x]")
        values = Object.keys(rawValues).reduce((res, key) => {
            let val = rawValues[key];

            if (key.indexOf('[') > -1) {
                key = key.split('[')[0];

                res[key] = res[key] || [];

                if (val) {
                    res[key].push(val);
                }
            } else {
                if (Array.isArray(val)) {
                    let valIndex = val.findIndex(v => v != null);
                    res[key] = val[valIndex];
                } else {
                    res[key] = val; 
                }                
            }

            return res;
        }, {});  
    }

    return values; 
}
